import React from "react";
import { Helmet } from "react-helmet";

const HeaderTag = () => {
  const appId = process.env.REACT_APP_APPLICATION_ID;

  const config = {
    "gat-rescue-frontend": {
      title: "Rescue Assistansbolaget",
      description:
        "Get a price estimate, estimated time of arrival, and GPS location with GAT.",
      image: "https://rescue.assistansbolaget.com/images/rescue.png",
      url: "https://rescue.assistansbolaget.nu",
      type: "website",
      canonical: "https://rescue.assistansbolaget.nu",
      itemPropDescription: "Get towing assistance | GAT",
      itemPropDescriptionTwo:
        "Get a price estimate, estimated time of arrival, and GPS location with GAT."
    },
    "gat-rescue-dk": {
      title: "Rescue Assist24",
      description:
        "Get a price estimate, estimated time of arrival, and GPS location with GAT.",
      canonical: "https://rescue.assist24.dk",
      type: "website"
    }
  };

  const currentConfig = config[appId] || {};

  return (
    <>
      <Helmet encodeSpecialCharacters={false}>
        <title>{currentConfig.title}</title>
        <meta name="description" content={currentConfig.description} />
        <meta itemProp="name" content={currentConfig.itemPropDescription} />
        <meta
          itemProp="description"
          content={currentConfig.itemPropDescriptionTwo}
        />
        <meta property="og:url" content={currentConfig.url} />
        <meta property="og:type" content={currentConfig.type} />
        <meta property="og:title" content={currentConfig.title} />
        <meta property="og:description" content={currentConfig.description} />
        <link rel="canonical" href={currentConfig.canonical} />
        <meta name="msapplication-TileColor" content="#ffffff" />
        <meta name="theme-color" content="#ffffff" />
      </Helmet>
    </>
  );
};

export default HeaderTag;
